
export default function Footer() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-teal-600 via-teal-700 to-teal-800 text-white">
      <div className="max-w-7xl mx-auto px-8 py-20">
        <div className="grid grid-cols-3 gap-16 mb-16">
          <div className="pr-8">
            <div className="flex items-center gap-2 mb-6">
              <img 
                src="https://public.readdy.ai/ai/img_res/84612608-2987-46a9-95ff-5e019e6ef485.png" 
                alt="FRIGOAVE Logo" 
                className="h-12 w-auto brightness-0 invert"
              />
            </div>
            <p className="text-base text-white/70 leading-relaxed mb-8 max-w-xs">
              Providing secure and reliable VPN solutions to protect your digital privacy and freedom online
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="w-9 h-9 flex items-center justify-center border-2 border-white/30 rounded-full hover:bg-white/10 transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center border-2 border-white/30 rounded-full hover:bg-white/10 transition-colors cursor-pointer">
                <i className="ri-twitter-x-fill text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center border-2 border-white/30 rounded-full hover:bg-white/10 transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center border-2 border-white/30 rounded-full hover:bg-white/10 transition-colors cursor-pointer">
                <i className="ri-instagram-fill text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-sm text-white/50 uppercase tracking-wider mb-6 whitespace-nowrap">QUICK LINKS</h3>
            <div className="space-y-4">
              <button onClick={() => scrollToSection('home')} className="block text-base text-white/70 hover:text-white transition-colors cursor-pointer whitespace-nowrap">
                Home
              </button>
              <button onClick={() => scrollToSection('about')} className="block text-base text-white/70 hover:text-white transition-colors cursor-pointer whitespace-nowrap">
                About Us
              </button>
              <button onClick={() => scrollToSection('vpn-service')} className="block text-base text-white/70 hover:text-white transition-colors cursor-pointer whitespace-nowrap">
                VPN Service
              </button>
              <button onClick={() => scrollToSection('security')} className="block text-base text-white/70 hover:text-white transition-colors cursor-pointer whitespace-nowrap">
                Security &amp; Privacy
              </button>
              <button onClick={() => scrollToSection('support')} className="block text-base text-white/70 hover:text-white transition-colors cursor-pointer whitespace-nowrap">
                Support
              </button>
              <button onClick={() => scrollToSection('contact')} className="block text-base text-white/70 hover:text-white transition-colors cursor-pointer whitespace-nowrap">
                Contact
              </button>
            </div>
          </div>

          <div>
            <h3 className="text-sm text-white/50 uppercase tracking-wider mb-6 whitespace-nowrap">CONTACT US</h3>
            <div className="space-y-5">
              <div>
                <p className="text-base text-white/70 leading-relaxed">
                  Rua CUSTODIO FREIRE 166<br />
                  RIO BRANCO, 69900-553, Brazil
                </p>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-phone-line text-lg"></i>
                <span className="text-base text-white/70 whitespace-nowrap">+1 785-599-7188</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-mail-line text-lg"></i>
                <span className="text-base text-white/70 break-all">support@frigoaveriobrancoltda.com</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8">
          <div className="flex items-center justify-between">
            <p className="text-sm text-white/50">
              © 2025 FRIGOAVE RIO BRANCO LTDA. All rights reserved.
            </p>
            <div className="flex items-center gap-8">
              <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="text-sm text-white/50 hover:text-white transition-colors cursor-pointer whitespace-nowrap">
                Powered by Readdy
              </a>
              <a href="#" className="text-sm text-white/50 hover:text-white transition-colors cursor-pointer whitespace-nowrap">
                Privacy Policy
              </a>
              <a href="#" className="text-sm text-white/50 hover:text-white transition-colors cursor-pointer whitespace-nowrap">
                Terms of Service
              </a>
              <a href="#" className="text-sm text-white/50 hover:text-white transition-colors cursor-pointer whitespace-nowrap">
                Cookie Policy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
